import React from 'react';
import { NextPage } from 'next';
import { useFirestore } from 'reactfire';
import { useAuth } from '@/hooks/useAuth';
import useTeam from '@/hooks/useTeam';
import Pricing from '@/features/Pricing';

const PricingPage: NextPage = () => {
  const { user } = useAuth();
  const firestore = useFirestore();
  const { data: team } = useTeam(firestore, user?.teamId || 'undefined');

  return <Pricing user={user} team={team} />;
};

export default PricingPage;
